import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AutoRefreshService {

  private isEnabled$ = new BehaviorSubject<boolean>(true);

  refreshState$ = this.isEnabled$.asObservable();

  toggle(state: boolean) {
    this.isEnabled$.next(state);
  }

  get currentState() {
    return this.isEnabled$.value;
  }
}
